import authService from '@/services/auth';
import { formatRoute } from '@/utils/route-helper';

/**
 * Busca un elemento del menú que coincida con la ruta actual
 * @param {string} routePath - La ruta actual
 * @returns {object|null} El elemento del menú encontrado o null
 */
function findMenuItemByRoute(routePath) {
  const userMenu = authService.getUserMenu();
  
  if (!userMenu || !Array.isArray(userMenu)) {
    return null;
  }

  // Normalizar la ruta actual
  const normalizedRoute = formatRoute(routePath);
  
  // Buscar coincidencia exacta primero
  let menuItem = userMenu.find(item => {
    const menuRoute = formatRoute(item.Enlace);
    return menuRoute === normalizedRoute;
  });
  
  // Si no encuentra coincidencia exacta, buscar coincidencias parciales
  if (!menuItem) {
    menuItem = userMenu.find(item => {
      const menuRoute = formatRoute(item.Enlace);
      return normalizedRoute.startsWith(menuRoute + '/') && menuRoute !== '/';
    });
  }
  
  return menuItem;
}

// Mapeo de rutas a títulos para la barra de título global (fallback)
export const routeTitles = {
  // Dashboard
  '/': {
    title: 'Dashboard',
    icon: 'bi-house-door',
    breadcrumb: 'Inicio'
  },
  
  // Autenticación
  '/login': {
    title: 'Iniciar Sesión',
    icon: 'bi-box-arrow-in-right',
    breadcrumb: 'Login'
  },
  '/perfil': {
    title: 'Mi Perfil',
    icon: 'bi-person-badge',
    breadcrumb: 'Perfil'
  },
  
  // Menús
  '/menus': {
    title: 'Gestión de Menús',
    icon: 'bi-list-ul',
    breadcrumb: 'Menús'
  },
  '/menus/add': {
    title: 'Agregar Menú',
    icon: 'bi-plus-circle',
    breadcrumb: 'Menús > Agregar'
  },
  '/menus/edit': {
    title: 'Editar Menú',
    icon: 'bi-pencil-square',
    breadcrumb: 'Menús > Editar'
  },
  '/menus-table1': {
    title: 'Tabla de Menús 1',
    icon: 'bi-table',
    breadcrumb: 'Menús > Tabla 1'
  },
  '/menus-table2': {
    title: 'Tabla de Menús 2',
    icon: 'bi-table',
    breadcrumb: 'Menús > Tabla 2'
  },
  '/menus-table3': {
    title: 'Tabla de Menús 3',
    icon: 'bi-table',
    breadcrumb: 'Menús > Tabla 3'
  },
  '/menus-table4': {
    title: 'Tabla de Menús 4',
    icon: 'bi-table',
    breadcrumb: 'Menús > Tabla 4'
  },
  '/menus-selection': {
    title: 'Selección de Menús',
    icon: 'bi-check2-square',
    breadcrumb: 'Menús > Selección'
  },
  
  // Parámetros
  '/parametros': {
    title: 'Gestión de Parámetros',
    icon: 'bi-gear',
    breadcrumb: 'Parámetros'
  },
  '/parametros/add': {
    title: 'Agregar Parámetro',
    icon: 'bi-plus-circle',
    breadcrumb: 'Parámetros > Agregar'
  },
  '/parametros/edit': {
    title: 'Editar Parámetro',
    icon: 'bi-pencil-square',
    breadcrumb: 'Parámetros > Editar'
  },
  
  // Usuarios
  '/usuarios': {
    title: 'Gestión de Usuarios',
    icon: 'bi-people',
    breadcrumb: 'Usuarios'
  },
  '/usuarios/add': {
    title: 'Agregar Usuario',
    icon: 'bi-person-plus',
    breadcrumb: 'Usuarios > Agregar'
  },
  '/usuarios/edit': {
    title: 'Editar Usuario',
    icon: 'bi-person-gear',
    breadcrumb: 'Usuarios > Editar'
  },
  
  // Grupos de Usuario
  '/grupous': {
    title: 'Grupos de Usuario',
    icon: 'bi-people-fill',
    breadcrumb: 'Grupos'
  },
  '/grupous/add': {
    title: 'Agregar Grupo',
    icon: 'bi-plus-circle',
    breadcrumb: 'Grupos > Agregar'
  },
  '/grupous/edit': {
    title: 'Editar Grupo',
    icon: 'bi-pencil-square',
    breadcrumb: 'Grupos > Editar'
  },
  
  // Módulos
  '/modulos': {
    title: 'Gestión de Módulos',
    icon: 'bi-grid-3x3-gap',
    breadcrumb: 'Módulos'
  },
  '/modulos/add': {
    title: 'Agregar Módulo',
    icon: 'bi-plus-circle',
    breadcrumb: 'Módulos > Agregar'
  },
  '/modulos/edit': {
    title: 'Editar Módulo',
    icon: 'bi-pencil-square',
    breadcrumb: 'Módulos > Editar'
  },
  
  // Motivos de Rechazo
  '/motivos-rechazo': {
    title: 'Motivos de Rechazo',
    icon: 'bi-x-circle',
    breadcrumb: 'Motivos de Rechazo'
  },
  '/motivos-rechazo/add': {
    title: 'Agregar Motivo de Rechazo',
    icon: 'bi-plus-circle',
    breadcrumb: 'Motivos > Agregar'
  },
  '/motivos-rechazo/edit': {
    title: 'Editar Motivo de Rechazo',
    icon: 'bi-pencil-square',
    breadcrumb: 'Motivos > Editar'
  },
  
  // Módulo de Compras - Pedidos
  '/compras/pedidos': {
    title: 'Pedidos de Compra',
    icon: 'bi-cart-plus',
    breadcrumb: 'Compras > Pedidos'
  },
  '/compras/pedidos/nuevo': {
    title: 'Nuevo Pedido de Compra',
    icon: 'bi-plus-circle',
    breadcrumb: 'Compras > Pedidos > Nuevo'
  },
  '/compras/pedidos/editar': {
    title: 'Editar Pedido de Compra',
    icon: 'bi-pencil-square',
    breadcrumb: 'Compras > Pedidos > Editar'
  },
  '/compras/pedidos/ver': {
    title: 'Ver Pedido de Compra',
    icon: 'bi-eye',
    breadcrumb: 'Compras > Pedidos > Ver'
  },
  
  // Módulo POS - Compras de Chatarra
  '/posw2/compras': {
    title: 'POS - Compras de Chatarra',
    icon: 'bi-cash-coin',
    breadcrumb: 'POS > Compras Chatarra'
  },
  
  // Rutas de prueba
  '/simple-test': {
    title: 'Prueba Simple',
    icon: 'bi-bug',
    breadcrumb: 'Test > Simple'
  },
  '/compras-test': {
    title: 'Prueba de Compras',
    icon: 'bi-bug',
    breadcrumb: 'Test > Compras'
  }
};

/**
 * Obtiene el título de una ruta específica
 * @param {string} routePath - La ruta actual
 * @returns {object} Objeto con title, icon y breadcrumb
 */
export function getRouteTitle(routePath) {
  // Primero intentar obtener información del menú dinámico del usuario
  const menuItem = findMenuItemByRoute(routePath);
  
  if (menuItem) {
    return {
      title: menuItem.Titulo,
      icon: menuItem.Imagen ? `bi-${menuItem.Imagen}` : 'bi-file-earmark',
      breadcrumb: menuItem.Titulo
    };
  }
  
  // Fallback: Buscar en el mapeo estático
  // Buscar coincidencia exacta primero
  if (routeTitles[routePath]) {
    return routeTitles[routePath];
  }
  
  // Buscar coincidencias parciales para rutas dinámicas (con parámetros)
  for (const route in routeTitles) {
    // Para rutas como /usuarios/edit/:id, buscar /usuarios/edit
    if (routePath.startsWith(route + '/') && route !== '/') {
      return routeTitles[route];
    }
  }
  
  // Si no se encuentra ni en el menú ni en el mapeo estático, mostrar la ruta actual
  return {
    title: routePath === '/' ? 'Inicio' : routePath,
    icon: 'bi-file-earmark',
    breadcrumb: routePath === '/' ? 'Inicio' : routePath
  };
}